export default [
  {
    name: 'Home',
    icon: 'nc-icon nc-bank',
    path: '/overview',
    module: 'dashboard',
    action: 'view'
  },

  {
    name: 'Voters',
    icon: 'fa fa-users',
    path: '/voters',
    module: 'voters',
    action: 'view'
  },

  {
    name: 'Barangays',
    icon: 'fa fa-users',
    path: '/barangays',
    module: 'barangays',
    action: 'view'
  },

  {
    name: 'Voter Imports',
    icon: 'fa fa-upload',
    path: '/imports',
    module: 'imports',
    action: 'view'
  },

  {
    name: 'Scanned Uploads',
    icon: 'fa fa-upload',
    path: '/uploads',
    module: 'scanned_voter_uploads',
    action: 'view'
  },

  {
    name: 'Settings',
    icon: 'nc-icon nc-single-copy-04',
    collapsed: true,
    module: 'settings',
    children: [
      {
        name: 'Users',
        path: '/settings/users',
        module: 'users',
        action: 'view'
      },
      {
        name: 'Roles',
        path: '/settings/roles',
        module: 'roles',
        action: 'view'
      },
      {
        name: 'Settings',
        path: '/settings/configure',
        module: 'settings',
        action: 'view'
      }
    ]
  },
]
